import { render, staticRenderFns } from "./TaskDropdown.vue?vue&type=template&id=485cb64f&"
import script from "./TaskDropdown.vue?vue&type=script&lang=ts&"
export * from "./TaskDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports